import {ExhibitFilters} from "../../services/ngage/exhibits";
import {useQuery} from "react-query";
import ngage from "../../services/ngage";

export default function useGetExhibits(
  criteria: ExhibitFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['exhibits.all', criteria],
    () => ngage.exhibits.filtered(criteria),
    {enabled, keepPreviousData}
  );
}